import autobind from 'autobind-decorator';
import * as React from 'react';
import * as _ from 'lodash';
import InputContainer from 'login-components/Common/Inputs/InputContainer/InputContainer';
import FastForwardOptions from '../FastForwardOptions/FastForwardOptions';
import './ApplicationDetailsForm.scss';

interface ApplicationDetailsFormProps extends FastForwardApplicationConfig {
  onChange(any): void;
  borrowerTypes: string[];
  coborrowerOptions: string[];
  dataSharingOptions: string[];
  mortgageTypes: string[];
  loanTypes: ILoanType[];
  expanded: boolean;
}

interface ApplicationDetailsState {
  expanded: boolean;
}

@autobind
class ApplicationDetailsForm extends React.Component<ApplicationDetailsFormProps, ApplicationDetailsState> {
  constructor(props) {
    super(props);
    this.state = _.pick(this.props, 'expanded');
  }

  handleChange(e) {
    const { onChange } = this.props;
    const value = e.currentTarget.value;
    const propName = e.currentTarget.name;
    onChange({ [propName]: value });
  }

  toggleExpand() {
    this.setState({ expanded: !this.state.expanded });
  }

  render() {
    const {
      loanTypes,
      loanType,
      borrowerTypes,
      borrowerType,
      coborrowerOptions,
      dataSharingOptions,
      mortgageTypes,
      borrowerEmail,
    } = this.props;
    const { expanded } = this.state;
    if (!expanded) {
      return (
        <div className="ApplicationDetailsForm">
          <div className="ApplicationDetailsForm-clickableLabel" onClick={this.toggleExpand}>
            Application Details <i className="bl-icon icon-caret" />
          </div>
        </div>
      );
    }
    return (
      <div className="ApplicationDetailsForm">
        <div className="ApplicationDetailsForm-clickableLabel" onClick={this.toggleExpand}>
          Application Details <i className="bl-icon icon-caret-up" />
        </div>
        {loanTypes.length > 1 && (
          <FastForwardOptions
            options={_.map(loanTypes, 'text')}
            optionName="loanType"
            defaultValue={loanTypes[0].text}
            title="Loan Type"
            onChange={this.handleChange}
          />
        )}
        <div className="ApplicationDetailsForm-inputWrapper">
          <FastForwardOptions
            options={borrowerTypes}
            optionName="borrowerType"
            defaultValue="Single Borrower"
            title="Borrower Type"
            onChange={this.handleChange}
          />
          {borrowerType === 'Coborrowers' && (
            <FastForwardOptions
              options={coborrowerOptions}
              optionName="coborrowerOption"
              defaultValue="Married"
              title="Marital Status"
              onChange={this.handleChange}
            />
          )}
          {borrowerType === 'Coborrowers' && (
            <FastForwardOptions
              options={dataSharingOptions}
              optionName="dataSharingOption"
              defaultValue="Unrestricted Data"
              title="Data Sharing"
              onChange={this.handleChange}
            />
          )}
          {_.find(loanTypes, { text: loanType })!.value === 'MORTGAGE' && (
            <FastForwardOptions
              options={mortgageTypes}
              optionName="mortgageType"
              defaultValue="Purchasing a new home"
              title="Loan Purpose Type"
              onChange={this.handleChange}
            />
          )}
        </div>
        <div className="ApplicationDetailsForm-inputWrapper">
          <InputContainer icon="email-2" name="borrowerEmail" identifier="Borrower email">
            <input
              className="ApplicationDetailsForm-emailInput"
              type="email"
              placeholder="Borrower Email"
              name="borrowerEmail"
              value={borrowerEmail}
              onChange={this.handleChange}
            />
          </InputContainer>
        </div>
      </div>
    );
  }
}

export default ApplicationDetailsForm;
